import * as React from "react";
import { Card, CardContent } from "@mui/material";
import { FilterLiveSearch } from "react-admin";

const DeliveryCodeInput = () => (
  <Card>
    <CardContent>
      <h3>1. <b>Ingresa el código de 6 dígitos</b> que te indique el cliente:</h3>
      <FilterLiveSearch label="Código de 6 dígitos" source="deliveryCode" />
    </CardContent>
  </Card>
);

export default DeliveryCodeInput;
